/**
 * TradingCard Component - 交易卡片主組件
 * Requirements: 7.1, 7.2, 7.3, 7.4, 7.5
 * 
 * 組合所有子組件、根據商品類型條件渲染、支援 ref 用於圖片導出
 */

import { forwardRef } from 'react';
import type { CardData, CalculationResult } from '../../types/card';
import type { Translations } from '../../i18n';
import { CardHeader } from './CardHeader';
import { SpecsBlock } from './SpecsBlock';
import { FinanceBlock } from './FinanceBlock';
import { ContactBadges } from './ContactBadges';

interface TradingCardProps {
  cardData: CardData;
  result: CalculationResult;
  t: Translations;
}

/**
 * TradingCard - 交易卡片主組件
 * 使用 forwardRef 支援外部獲取 DOM 引用，用於圖片導出功能
 */
export const TradingCard = forwardRef<HTMLDivElement, TradingCardProps>(
  function TradingCard({ cardData, result, t }, ref) {
    return (
      <div
        ref={ref}
        className="bg-white rounded-lg shadow-lg overflow-hidden w-full max-w-lg mx-auto"
      >
        {/* 卡片頭部 - 深色背景區域 */}
        <CardHeader cardData={cardData} t={t} />

        {/* 規格區塊 - 根據商品類型條件渲染 */}
        <SpecsBlock cardData={cardData} t={t} />

        {/* 財務區塊 - 價格和剩餘價值資訊 */}
        <FinanceBlock cardData={cardData} result={result} t={t} />

        {/* 聯繫徽章 - Telegram 和交易平台 */}
        <ContactBadges contact={cardData.contact} t={t} />

        {/* 底部品牌標識 */}
        <div className="px-4 py-2 bg-slate-50 text-center">
          <p className="text-xs text-slate-400">
            Generated by MJJ Trading Tool
          </p>
        </div>
      </div>
    );
  }
);

export default TradingCard;
